import BvInline from 'volta/components/bv-inline';
import BvText from 'volta/components/bv-text';

import type { TOC } from '@ember/component/template-only';
import type { ContentValue } from '@glint/template';

export interface BvModalSectionHeaderSignature {
  Args: {
    title: ContentValue;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

const BvModalSectionHeaderComponent: TOC<BvModalSectionHeaderSignature> = <template>
  <header class='bv-modal__section-header' ...attributes>
    {{#if @title}}
      <BvInline @align='space-between' @blockAlign='center'>
        {{#if @title}}
          <BvText @variant='heading-sm' class='u-flex-1'>
            {{@title}}
          </BvText>
        {{/if}}
        {{yield}}
      </BvInline>
    {{else}}
      {{yield}}
    {{/if}}
  </header>
</template>;

export default BvModalSectionHeaderComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'BvModal::SectionHeader': typeof BvModalSectionHeaderComponent;
    'bv-modal/section-header': typeof BvModalSectionHeaderComponent;
  }
}
